import intersection from 'lodash/intersection';
import uniq from 'lodash/uniq';

export function filterAndMergeArrays<TValue>(array1: TValue[], array2: TValue[]) {
    // Find commons entries between array1 et array2
    const commonElements = intersection(array1, array2);

    // Merge commons entries with array2
    const mergedArray = uniq([...commonElements, ...array2]);

    return mergedArray;
}
